import type { Permission } from '@cobliteam/permissions';
import type { RouteDef } from '../../../dashboardDef.type';

// `permission` pode ser uma permissão única ou uma lista com semântica OR (ex.: basic-value,
// AE-2446) — isAccessAllowed já resolve as duas formas.
const getRoutesWithPermission = (routesDef: RouteDef[], isAccessAllowed: (permission: Permission | Permission[]) => boolean) => {
  const routesDefWithPermission = routesDef.filter((nav) => {
    if (!nav.permission) return false;

    if (nav.routes) {
      nav.routes = nav.routes.filter((route) => {
        if (route.routes) {
          route.routes = route.routes.filter((group) => isAccessAllowed(group.permission as Permission | Permission[]));
        }
        return isAccessAllowed(route.permission as Permission | Permission[]);
      });

      return nav.routes.length > 0;
    }

    return isAccessAllowed(nav.permission as Permission | Permission[]);
  });

  return routesDefWithPermission;
};

export default getRoutesWithPermission;
